module.exports = __webpack_public_path__ + "static/media/Fashion-store-587411-min.e944b97e.jpg";